import * as moment from 'moment'

import { Enums, FileExtension } from '../common/enums'

import { ConvertHelper } from '../../helpers/convert-helper'

import { IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'

import { OpDescr } from './op-descr'

export class OpFile implements IReferenceType, IOpChangeState, IJsonSerializable {

    // Properties

    public idFile: number
    public idDescr: number
    public fileBytes: number[] | string
    public description: string
    public isBlocked: boolean = false
    public physicalFileName: string
    public size: number
    public version: string = null

    private _insertDate: string
    public get insertDate(): Date {
        if (this._insertDate != null) {
            return ConvertHelper.stringToDate(this._insertDate)
        }

        return null
    }

    public set insertDate(value: Date) {
        let dateString: string = null

        if (value != null) {
            dateString = ConvertHelper.dateToString(value, { netFormat: true })
        }

        this._insertDate = dateString
    }

    public _lastDownloaded: string = null
    public get lastDownloaded(): Date {
        if (this._lastDownloaded != null) {
            return ConvertHelper.stringToDate(this._lastDownloaded)
        }
        
        return null
    }

    public set lastDownloaded(value: Date) {
        let dateString: string = null

        if (value != null) {
            dateString = ConvertHelper.dateToString(value, { netFormat: true })
        }

        this._lastDownloaded = dateString
    }

    // Properties End


    // Navigational Properties

    public descr: OpDescr

    // Navigational Properties End


    // Custom Properties

    public get extension(): FileExtension {
        if (this.physicalFileName) {
            var ext = this.physicalFileName.split('.').pop()
            var enums: any = FileExtension
            for (var ex in FileExtension) {
                if (ex.toUpperCase() == ext.toUpperCase())
                    return enums[ex]
            }
        } else {
            throw new Error('Physical file name is null')
        }
        return FileExtension.Unknown
    }

    // Custom Properties End


    // Ctor

    constructor(opObj: any = null) {
        this.fromJSON(opObj)
    }

    // Ctor End


    // IOpChangeState Implementation

    public opState: Enums.OpChangeState

    // IOpChangeState Implementation End


    // IReferenceType Implementation

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdFile
    }

    public getReferenceKey(): number {
        return this.idFile
    }

    public getReferenceValue(): any {
        return this
    }

    // IReferenceType Implementation End


    // IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idFile = opObj.ID_FILE
            this.fileBytes = opObj.FILE_BYTES

            this._insertDate = opObj.INSERT_DATE
            this._lastDownloaded = opObj.LAST_DOWNLOADED

            this.isBlocked = opObj.IS_BLOCKED
            this.physicalFileName = opObj.PHYSICAL_FILE_NAME
            this.size = opObj.SIZE
            this.version = opObj.VERSION

            this.idDescr = opObj.ID_DESCR
            this.descr = opObj._Descr ? new OpDescr(opObj._Descr) : null
            this.description = opObj.DESCRIPTION ? opObj.DESCRIPTION : null

            this.opState = opObj.OpState
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_FILE: this.idFile,
            FILE_BYTES: this.fileBytes,
            INSERT_DATE: this._insertDate,
            LAST_DOWNLOADED: this._lastDownloaded,
            IS_BLOCKED: this.isBlocked,
            PHYSICAL_FILE_NAME: this.physicalFileName,
            SIZE: this.size,
            OpState: this.opState,
            VERSION: this.version,
            DESCRIPTION: this.description
        }
    }

    // IJsonSerializable Implementation End


    public toString() {
        return this.physicalFileName
    }

    public static isType(obj: any, isLocal: boolean = true) {
        if (isLocal && obj.idFile && obj.physicalFileName && obj.fileBytes) {
            return true
        } else if (!isLocal && obj.ID_FILE && obj.FILE_BYTES && obj.PHYSICAL_FILE_NAME) {
            return true
        }
        return false
    }
}